var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-field"},[_vm._t("default"),_c('span',{staticClass:"error-field__message"},[_vm._v(_vm._s(_vm.error))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }